"use client";

import { useEffect, useState } from "react";
import { useMeQuery, User } from "../../generated/graphql";

export type RefetchUserFn = () => void;

export function useUser(): [User | undefined, (user: User | undefined) => void, RefetchUserFn] {
    const [user, setUser] = useState<User | undefined>(() => {
        if (typeof window !== 'undefined') {
            const storedUser = localStorage.getItem('Local_stored_user');
            return storedUser ? JSON.parse(storedUser) : undefined;
        }
        return undefined;
    });

    const { data, refetch: meRefetch } = useMeQuery({
        fetchPolicy: "cache-and-network",
    });

    useEffect(() => {
        if (data?.me) {
            updateUser(data.me);
        }
    }, [data]);

    const updateUser = (_user: User | undefined) => {
        if (_user) {
            const userString = JSON.stringify(_user);
            if (localStorage.getItem('Local_stored_user') !== userString) {
                localStorage.setItem('Local_stored_user', userString);
                setUser(_user);
            }
        } else {
            localStorage.removeItem('Local_stored_user');
            setUser(undefined);
        }
    };

    const refetchUser = async () => {
        try {
            const { data } = await meRefetch();
            updateUser(data?.me);
        } catch (error) {
            console.error('Error refetching user:', error);
        }
    };

    return [user, updateUser, refetchUser];
}


